
import { State, Getter } from 'vuex-class';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ModalSection from '@/components/shared/ModalSection.vue';
import { TermsOfService } from '@/store/termsOfService/types';
import store from '@/store';
import { APIBaseRoute, EP } from '@/api-endpoints';
import { mixins } from "vue-class-component";
import { LogoutMixin } from "@/mixins/logout-mixin";

@Component({
  components: {
    ModalSection
  }
})
export default class DeclineTermsOfServiceModal extends mixins(LogoutMixin) {
  @Getter('getTermsOfService', { namespace: 'termsOfService' }) private termsOfService!: TermsOfService;

  public initializeModal(): void {
    const targetModal = this.$refs.termsOfServiceDeclineModal as ModalSection;
    targetModal.toggleStaticModal();
  }

  // Close modal
  private closeDeclineModal(): void {
    const targetModal = this.$refs.termsOfServiceDeclineModal as ModalSection;
    targetModal.hideModal();
    this.$emit("closeDeclineModal");
  }

  // emits closeDeclineModal on hide event to ungrey out the Main ToS Modal.
  private modalEvent(options: any) {
    this.$emit("closeDeclineModal");
  }

  get tosVersion(): string {
    return this.termsOfService?.version || '';
  }
}
